// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"StatisticsModal_modalTitle__qb_Pl","contentWrapper":"StatisticsModal_contentWrapper__1XJrO"};